<template>
  <el-dialog
    title="导出EXCEL文件"
    custom-class="layout-progress-dialog"
    :visible.sync="visible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="close"
    width="380px">
    <div v-loading="loading">
      <p class="layout-progress-name">{{lastFileName}}.{{fileType}}</p>
      <el-progress :text-inside="true"
                   :stroke-width="18"
                   :percentage="percentage"
                   :status="progressStatus"></el-progress>
    </div>
    <span slot="footer">
      <span v-if="loading"
            class="layout-progress-alert">正在查找数据中……</span>
      <span v-else
            class="layout-progress-alert">{{progressMessage}}</span>
      <!--操作按钮-->
      <el-button v-show="status === 'end' || status === 'stop'"
                 type="primary"
                 size="small"
                 @click="download()">下 载</el-button>
      <el-button v-show="status === ''"
                 v-loading="loading"
                 type="primary"
                 size="small"
                 @click="start()">开 始</el-button>
      <el-button v-show="status === 'start'"
                 type="warning"
                 size="small"
                 @click="stop()">暂 停</el-button>
      <el-button v-show="status === 'stop'"
                 type="success"
                 size="small"
                 @click="start()">继 续</el-button>
      <el-button v-show="status === 'error' && retryTotal"
                 type="warning"
                 size="small"
                 @click="jump()">跳 过</el-button>
      <el-button v-show="status === 'error' && !retryTotal"
                 type="danger"
                 size="small"
                 @click="retry()">重 试</el-button>
    </span>
  </el-dialog>
</template>

<script>
import moment from 'moment'
import xlsx from '../xlsx'

export default {
  name: 'ExportExcelBox',
  data () {
    return {
      loading: false,
      visible: false,
      type: 'object', // object array
      total: 0,
      fileType: 'xlsx',
      fileName: 'unnamed',
      fileHeader: null,
      keyName: 'key',
      labelName: 'text',
      fileData: [],
      request: null,
      requestParams: {},
      getResponseData: (data) => data,
      currentPage: 1,
      perPage: 50,
      retryTotal: 0,
      autoDownload: true,
      autoStart: true,
      backendRequestParams: {},
      /**
       * 开始 start
       * 停止 stop
       * 结束 end
       * 错误 error
       */
      status: ''
    }
  },
  computed: {
    totalPage () {
      return Math.ceil(this.total / this.perPage)
    },
    lastFileName () {
      return this.fileName + '-' + moment().format('YYMMDDHHmmss') + 'T' + this.total
    },
    percentage () {
      let percentage = 0
      if (this.total > 0) {
        percentage = parseInt(((this.fileData.length / this.total) * 100))
        if (percentage > 100) {
          return 100
        }
      }
      return percentage
    },
    progressStatus () {
      switch (this.status) {
        case 'error':
          return 'exception'
        case 'end':
          return 'success'
        default:
          return null
      }
    },
    progressMessage () {
      if (this.total > 0) {
        switch (this.status) {
          case 'start':
            return '从服务器获取数据中，请不要关闭页面！'
          case 'stop':
            return '已暂停获取数据。'
          case 'end':
            return '数据已获取完毕，请点击下载获得Excel文件。'
          case 'error':
            if (this.retryTotal) {
              return '获取服务器数据再次发生了错误。'
            } else {
              return '获取服务器数据发生了错误。'
            }
          default:
            return `本次将导出${this.total}条数据。`
        }
      } else {
        return '没有找到导出的数据，请稍候重试。'
      }
    }
  },
  watch: {
    visible (val) {
      if (val && this.autoStart) {
        this.loading = true
        this.start()
      }
    }
  },
  methods: {
    start () {
      this.backendRequestParams = {}
      this.status = 'start'
      this.getData()
    },
    stop () {
      this.status = 'stop'
    },
    end () {
      this.status = 'end'
    },
    error () {
      this.status = 'error'
    },
    retry () {
      this.retryTotal++
      this.start()
    },
    jump () {
      this.retryTotal = 0
      this.currentPage++
      this.start()
    },
    reset () {
      Object.assign(this.$data, this.$options.data())
    },
    handleClose () {
      this.visible = false
      setTimeout(() => this.reset(), 250)
    },
    close () {
      // 直接关闭
      if (!this.total || this.status === 'end') {
        return this.handleClose()
      }
      // 关闭提示
      this.$confirm('确认终止导出数据吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        return this.handleClose()
      })
    },
    getTotal () {
      this.request(filter.copyJson({
        ...this.requestParams,
        current_page: 1,
        per_page: 0,
      })).then(({data}) => {
        this.total = data.total
        this.loading = false
      })
    },
    getData () {
      this.request(filter.copyJson({
        ...this.requestParams,
        ...this.backendRequestParams,
        current_page: this.currentPage,
        per_page: this.perPage,
      })).then(({data}) => {
        this.loading = false
        if (!this.total && data.total) {
          this.total = data.total
        }
        // 停止、结束下载
        if (['stop', 'end'].includes(this.status)) {
          return
        }
        // 获得响应
        data = this.getResponseData(data)

        if (data.backendRequestParams && Object.keys(data.backendRequestParams).length) {
          Object.assign(this.backendRequestParams, data.backendRequestParams)
        }

        // push 数据
        this.fileData.push.apply(this.fileData, data.data)
        // 数据总量是0条
        if (!this.total) {
          return this.end()
        }
        // 全部加载完成
        if (this.currentPage === this.totalPage) {
          setTimeout(() => {
            this.end()
            this.autoDownload && this.download()
          }, 250)
          return false
        }
        // 继续加载
        this.currentPage++
        this.getData()
      }, () => {
        this.error()
      })
    },
    download () {
      let fileData = []
      // 数据模式 第一行是表头
      if (this.type === 'array') {
        fileData = this.fileData
      }
      if (this.type === 'object') {
        // 获得表格 header
        let headerKeys = []
        let headerValue = []
        if (this.fileHeader && this.fileHeader.length) {
          this.fileHeader.forEach((row) => {
            headerKeys.push(row[this.keyName])
            headerValue.push(row[this.labelName])
          })
        }
        this.fileData.forEach((row) => {
          this.fileHeader.forEach((headerItem) => {
            if (headerItem.formatter) {
              const key = headerItem[this.keyName]
              row[key] = headerItem.formatter(row)
            }
          })
        })
        // 转换 object 为 array
        fileData = xlsx.ArrayObjectsToArrays(this.fileData, headerKeys)
        // 置入 header
        headerValue.length && (fileData[0] = headerValue)
      }
      xlsx.exportXlsx(fileData, {fileName: this.lastFileName, fileType: this.fileType})
      // 关闭
      this.status === 'end' && this.close()
    },
  },
}
</script>
<style lang="scss">
.layout-progress-dialog {
  .el-dialog__body {
    padding: 0px 20px 15px;
  }

  .el-dialog__footer {
    padding: 15px 20px;
  }

  .layout-progress-name {
    font-size: 12px;
    display: block; /*内联对象需加*/
    word-break: keep-all; /* 不换行 */
    white-space: nowrap; /* 不换行 */
    overflow: hidden; /* 内容超出宽度时隐藏超出部分的内容 */
    text-overflow: ellipsis; /* 当对象内文本溢出时显示省略标记(...) ；需与overflow:hidden;一起使用。*/
    width: 340px; /* 长度限制 */
  }

  .layout-progress-alert {
    font-size: 10px;
    color: #f56c6c;
    float: left;
    line-height: 32px;
  }
}
</style>



// WEBPACK FOOTER //
// core/components/ExportExcelBox/src/main.vue